"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calendar_filter_html_1 = __importDefault(require("./calendar-filter.html"));
var calendar_filter_controller_1 = __importDefault(require("./calendar-filter.controller"));
function dcCalendarFilters() {
    return {
        restrict: "E",
        scope: {
            context: "@",
        },
        template: calendar_filter_html_1.default,
        link: function (scope, element, attrs) { },
        controller: calendar_filter_controller_1.default,
        controllerAs: "vm",
        bindToController: true,
    };
}
dcCalendarFilters.$inject = [];
exports.default = dcCalendarFilters;
